// The purpose of this middleware is to just add a property "asyncDispatch" to all actions.
//
// The asyncDispatch property can be used in a reducer to asynchronously dispatch another action. When the
// reducer has completed and returned the new state, asyncDispatch will trigger store.dispatch with whatever
// action you gave it.

import type { AnyAction, Middleware } from '@reduxjs/toolkit';

const asyncDispatchMiddleware: Middleware = (store) => (next) => (action: any) => {
  let syncActivityFinished = false;
  let actionQueue: any[] = [];

  function flushQueue() {
    actionQueue.forEach((queuedAction) => store.dispatch(queuedAction));
    actionQueue = [];
  }

  function asyncDispatch(asyncAction: AnyAction) {
    actionQueue = actionQueue.concat([asyncAction]);

    if (syncActivityFinished) {
      flushQueue();
    }
  }

  const actionWithAsyncDispatch = { ...action, asyncDispatch };

  const returnValue = next(actionWithAsyncDispatch);
  syncActivityFinished = true;
  flushQueue();

  return returnValue;
};

export default asyncDispatchMiddleware;
